import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=5e2c7770&scoped=true"
import script from "./CardInfo.vue?vue&type=script&lang=ts"
export * from "./CardInfo.vue?vue&type=script&lang=ts"
import style0 from "./CardInfo.vue?vue&type=style&index=0&id=5e2c7770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2c7770",
  null
  
)

export default component.exports